"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var section_doubled_1 = require("../../sections/section-doubled");
/**
 * Doubled Section Constructor
 */
wp.customize.sectionConstructor['epsilon-section-doubled'] = wp.customize.Section.extend({
    ready: function () {
        var section = this;
        new section_doubled_1.EpsilonSectionDoubled(section);
    },
    attachEvents: function () {
    },
    isContextuallyActive: function () {
        return true;
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/vendors/epsilon-framework/customizer/extenders/sections/section-doubled.ts
// module id = 27
// module chunks = 0